// ipad-pwa/src/components/AlphaPad.jsx
// On-screen letter-only keypad for CathayID entry. CathayIDs are 4–10
// uppercase letters (e.g. CRWPKW), so this pad shows A–Z with no digits.
// Layout: 4 rows × 7 columns — the final row has 5 letters + Back + Clear.

const ROWS = [
  'ABCDEFG',
  'HIJKLMN',
  'OPQRSTU',
];
const LAST_ROW = 'VWXYZ';

export default function AlphaPad({ onKey, onBackspace, onClear, maxLen, value }) {
  const Btn = ({ label, onClick, variant = 'default' }) => {
    const styles = {
      default: 'bg-white hover:bg-slate-100 active:bg-slate-200 text-slate-800',
      danger: 'bg-slate-200 hover:bg-slate-300 active:bg-slate-400 text-slate-700',
    };
    return (
      <button
        type="button"
        onClick={onClick}
        className={
          'h-16 rounded-2xl border border-slate-200 text-3xl font-semibold shadow-sm transition ' +
          styles[variant]
        }
      >
        {label}
      </button>
    );
  };

  const press = (k) => {
    if (maxLen && value && value.length >= maxLen) return;
    onKey(k);
  };

  return (
    <div className="space-y-2 select-none w-full max-w-2xl mx-auto">
      {ROWS.map((row) => (
        <div key={row} className="grid grid-cols-7 gap-2">
          {row.split('').map((ch) => (
            <Btn key={ch} label={ch} onClick={() => press(ch)} />
          ))}
        </div>
      ))}
      <div className="grid grid-cols-7 gap-2">
        {LAST_ROW.split('').map((ch) => (
          <Btn key={ch} label={ch} onClick={() => press(ch)} />
        ))}
        <Btn label="←" onClick={onBackspace} variant="danger" />
        <Btn label="Clear" onClick={onClear} variant="danger" />
      </div>
    </div>
  );
}
